import { BackIcon } from "../../assests/svg/SvgIcons";

function BusinessStepper({ currentStep,prevStep ,showSuccess}) {
  return (
    <div className="stepper-wrapper">
      {currentStep > 1   && !showSuccess  &&(
        <div className="stepper-back-btn me-3" onClick={prevStep}>
          <BackIcon />
        </div>
      )}

      <div className={`step-box ${currentStep >= 1 ? "active-step" : ""}`}>
        Account & Bussiness details setup
      </div>

      <div className="step-line-div"></div>

      <div className={`step-box ${currentStep >= 2 ? "active-step" : ""}`}>
        Review Bussiness page
      </div>

      <div className="step-line-div"></div>

      <div className={`step-box ${currentStep >= 3 ? "active-step" : ""}`}>
        Payment
      </div>
    </div>
  );
}

export default BusinessStepper;
